<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="商家" prop="merchantId">
                <a-select show-search :filter-option="merchantFilter" v-model="queryParam.merchantId" :maxLength="32" :placeholder="$t('请选择')+'商家'" allow-clear>
                  <a-select-option v-for="item in merchantList" :key="item.id">{{ item.merchantName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="activityName">
                <span slot="label" ><a-tooltip>{{$t('活动标题')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.activityName" :maxLength="32" :placeholder="$t('请输入')+'活动标题'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="activityType">
                <span slot="label" ><a-tooltip>{{$t('活动类型')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-select v-model="queryParam.activityType" :placeholder="$t('请选择')+'活动类型'" allow-clear>
                  <a-select-option v-for="(item, index) in customDict.ActivityUsefulTypeEnum" :value="item.type" :key="index">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="suitableType">
                <span slot="label" ><a-tooltip>{{$t('适用商品类型')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-select v-model="queryParam.suitableType" :placeholder="$t('请选择')+'适用商品类型'" allow-clear>
                  <a-select-option v-for="(item, index) in customDict.CouponSuitableTypeEnum" :value="item.type" :key="index">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="status">
                <span slot="label" ><a-tooltip>{{$t('上架状态')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-select v-model="queryParam.status" :placeholder="$t('请选择')+'上架状态'" allow-clear>
                  <a-select-option v-for="(item, index) in customDict.CouponStatusEnum" :value="item.type" :key="index">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="活动状态" prop="activityTimeStatus">
                <a-select v-model="queryParam.activityTimeStatus" :placeholder="$t('请选择')+'活动状态'" allow-clear>
                  <a-select-option v-for="(item, index) in customDict.CouponTimeStatusEnum" :value="item.type" :key="index">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="isLimit">
              <span slot="label" ><a-tooltip>{{$t('是否限量')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-select :placeholder="$t('请选择')+$t('是否限量')" style="width: 100%" v-model="queryParam.isShow" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type+''" :key="index">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                   :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                   :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd()" v-hasPermi="['activity:activity:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['activity:activity:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['activity:activity:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['activity:activity:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" :level-list="levelList" @ok="getList"/>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: '1200' }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template slot="coverImg" slot-scope="text, record">
          <div>
            <img v-if="record.coverImg" :src="record.coverImg" style="width:60px;height:62px;" @click="handleRecordPreview(record.coverImg)" alt="none"/>
          </div>
        </template>
        <span slot="suitableType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.CouponSuitableTypeEnum" :color="true" :value="record.suitableType"/>
        </span>
        <span slot="activityType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.ActivityTypeEnum" :color="true" :value="Number(record.activityType)"/>
        </span>
        <span slot="status" slot-scope="text, record">
          <custom-dict-tag :options="customDict.CouponStatusEnum" :color="true" :color-array="['green', 'red']"  :value="record.status"/>
        </span>
        <span slot="activityTimeStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.CouponTimeStatusEnum" :color="true" :color-array="['blue', 'green', 'red',]" :value="record.activityTimeStatus"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['activity:activity:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['activity:activity:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['activity:activity:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['activity:activity:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
          <br>
          <a-divider type="vertical" v-hasPermi="['merchant:activity:edit']" />
          <a @click="handleOn(record)" v-if="!record.status " v-hasPermi="['merchant:activity:edit']">
             <a-icon type="edit" />{{$t('上架')}}
          </a>
          <a @click="handleOff(record)"  v-if="record.status" v-hasPermi="['merchant:activity:edit']">
             <a-icon type="edit" />{{$t('下架')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageActivity,statusActivity, delActivity } from '@/api/activity/activity'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import {listLevel} from "@/api/user/level";
import {listSelectMerchant, merchantStatus} from "@/api/merchant/merchantMerchant";

export default {
  name: 'Activity',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      levelList:[],
      merchantList:[],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        merchantId: undefined,
        merchantScope: undefined,
        activityTimeStatus: undefined,
        activityName: undefined,
        coverImg: undefined,
        posterImg: undefined,
        posterTxt: undefined,
        suitableType: undefined,
        discountType: undefined,
        startTime: undefined,
        endTime: undefined,
        limitMember: undefined,
        status: undefined,
        isLimit: undefined,
        limitNum: undefined,
        stock: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('编号'),
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: this.$t('商家名称'),
          dataIndex: 'merchantName',
          align: 'center'
        },
        {
          title: this.$t('活动类型'),
          dataIndex: 'activityType',
          scopedSlots: { customRender: 'activityType' },
          align: 'center'
        },
        {
          title: this.$t('活动标题'),
          dataIndex: 'activityName',
          align: 'center'
        },
        {
          title: this.$t('活动封面图'),
          dataIndex: 'coverImg',
          scopedSlots: { customRender: 'coverImg' },
          align: 'center'
        },
        {
          title: this.$t('适用商品类型'),
          dataIndex: 'suitableType',
          scopedSlots: { customRender: 'suitableType' },
          align: 'center'
        },
        {
          title: this.$t('开始时间'),
          dataIndex: 'startTime',
          align: 'center'
        },
        {
          title: this.$t('结束时间'),
          dataIndex: 'endTime',
          align: 'center'
        },
        {
          title: this.$t('上架状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'activityTimeStatus',
          scopedSlots: { customRender: 'activityTimeStatus' },
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getMerchantList()
    this.getList()
    this.getLevelList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询活动列表 */
    getList () {
      this.loading = true
     pageActivity(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    getLevelList () {
      this.loading = true
      listLevel({}).then(response => {
        this.levelList = response.data
      })
    },
    getMerchantList () {
      listSelectMerchant({}).then(response => {
        this.merchantList = response.data
        if (response.data.length === 1) {
          this.queryParam.merchantId = response.data[0].id;
        }
      })
    },
    merchantFilter(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        merchantId: undefined,
        merchantScope: undefined,
        activityTimeStatus: undefined,
        activityName: undefined,
        coverImg: undefined,
        posterImg: undefined,
        posterTxt: undefined,
        suitableType: undefined,
        discountType: undefined,
        startTime: undefined,
        endTime: undefined,
        limitMember: undefined,
        status: undefined,
        isLimit: undefined,
        limitNum: undefined,
        stock: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleAdd() {
      let merchantId = this.queryParam.merchantId;
      if (!merchantId) {
        this.$message.error('清先选择商家')
        return
      }
      merchantId;
      this.$refs.createForm.handleAdd(merchantId)
    },
    handleOn(record) {
      var that = this
      this.$confirm({
        title: this.$t('是否确认上架'),
        onOk () {
          return statusActivity({id:record.id,status: 1}).then(() => {
            that.onSelectChange([], [])
            const message = '上架成功'
            that.$message.success(message, 3)
            that.getList()
          })
        },
        onCancel () {}
      })
    },
    handleOff(record) {
      var that = this
      this.$confirm({
        title: this.$t('是否确认下架'),
        onOk () {
          return statusActivity({id:record.id,status: 0}).then(() => {
            that.onSelectChange([], [])
            const message = '下架成功'
            that.$message.success(message, 3)
            that.getList()

          })
        },
        onCancel () {}
      })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let reqData = {"idList":this.ids}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delActivity(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/activity/activity/export',
            that.queryParam
          , `活动_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
